<template>
  <app-modal
    ref="modal"
    v-bind="$attrs"
    class="modal-container"
    content-class="modal-medium"
    :title="
      settingType === 'vnConnect'
        ? '課金対象VNコネクト作成上限'
        : 'V番号全体のIPsec回線利用上限'
    "
  >
    <template v-if="isLoaded" v-slot:body="{ cancel }">
      <validation-observer v-slot="{ handleSubmit }" as="div">
        <v-form novalidate @submit.stop.prevent="handleSubmit(submit)">
          <!-- BODY -->
          <v-card-text class="pa-0">
            <div class="modal-body">
              <v-container>
                <!-- 利用中 -->
                <v-row>
                  <v-col>
                    <app-label-group
                      label="利用中"
                      :value="`${form.currentLimit}回線`"
                    />
                  </v-col>
                </v-row>
                <!-- 上限値 -->
                <v-row>
                  <v-col>
                    <app-badge item="上限値" msg="半角数字" />
                    <validation-provider
                      name="limit"
                      v-model.number="form.limit"
                      label="上限値"
                      :rules="{
                        required: true,
                        numeric: true,
                        between: { min: 0, max: 99999 },
                      }"
                      v-slot="{ componentField, errorMessage, meta }"
                    >
                      <app-form-input-number
                        v-bind="componentField"
                        :field-meta="meta"
                        :error-messages="errorMessage"
                      />
                    </validation-provider>
                  </v-col>
                </v-row>
              </v-container>
            </div>
          </v-card-text>

          <v-divider></v-divider>
          <!-- FOOTER -->
          <v-card-actions>
            <v-list-item class="w-100 pa-1">
              <template v-slot:append>
                <v-btn type="submit" color="primary" variant="flat">変更</v-btn>
                <v-btn @click="cancel" variant="outlined" color="primary"
                  >キャンセル</v-btn
                >
              </template>
            </v-list-item>
          </v-card-actions>
        </v-form>
      </validation-observer>
    </template>
  </app-modal>
</template>

<script lang="ts">
import type {
  UpperLimitOptionGetEntity,
  UpperLimitOptionUpdateEntity,
} from "@/apis/UpperLimitApi";
import { defineComponent } from "vue";
import type { PropType } from "vue";
import { VueFinalModal } from "vue-final-modal";

export default defineComponent({
  name: "LimitModify",
  props: {
    /** IPsec回線の上限値変更行う場合: ipSecLine
     * VNコネクトの上限値変更行う場合: vnConnect */
    settingType: {
      type: String as PropType<string>,
      required: true,
    },
  },
  data() {
    return {
      form: {
        currentLimit: 0,
        limit: 0,
      },
      limit: {} as UpperLimitOptionGetEntity,
      isLoaded: false,
    };
  },
  async mounted() {
    /** 契約単位（オプション契約）の設定上限値（最大値と現在値）取得API呼び出す処理 */
    this.limit = await this.$api.upperLimit.getUpperLimitOption();

    if (this.settingType === "vnConnect") {
      this.form.currentLimit = this.limit.vnConnect?.numberOfVnConnect || 0;
      this.form.limit = this.limit.vnConnect?.upperLimitVnConnect || 0;
    } else if (this.settingType === "ipSecLine") {
      this.form.currentLimit = this.limit.ipsec?.numberOfIpsec || 0;
      this.form.limit = this.limit.ipsec?.upperLimitIpsec || 0;
    }
    this.isLoaded = true;
  },
  methods: {
    async submit() {
      /** 確認モーダル表示 */
      await this.$confirm(`上限値を変更します。よろしいですか？`);

      const data: UpperLimitOptionUpdateEntity = {
        upperLimitContractKeyId: this.limit.upperLimitContractKeyId,
        upperLimitVnConnect:
          this.settingType === "vnConnect"
            ? this.form.limit
            : this.limit.vnConnect?.upperLimitVnConnect ?? null,
        upperLimitIpsec:
          this.settingType === "ipSecLine"
            ? this.form.limit
            : this.limit.ipsec?.upperLimitIpsec ?? null,
      };

      /** 契約単位（オプション契約）の設定上限値（最大値と現在値）更新API呼び出す処理 */
      await this.$api.upperLimit.updateUpperLimitOption(data);
      (this.$refs.modal as typeof VueFinalModal & { ok: () => void }).ok();
    },
  },
});
</script>
